import { put, call, fork, select, throttle, all, takeEvery } from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import * as routes from '../../components/index/routes';
import { reset as resetForm, stopSubmit } from 'redux-form';
import * as userInterestsModule from '../modules/userInterests.module';
import * as Api from '../../core/api';

export function* fetchUserInterests({ payload: { page, itemsPerPage } }) {
  const sort = yield select((state) => state.userInterests.sort);
  const filter = yield select((state) => state.userInterests.filter);

  const { response, error } = yield call(Api.users.fetchUserInterests, { page, itemsPerPage, sort, filter });

  if (response) {
    yield put(userInterestsModule.fetchUserInterestsSuccess({ userInterests: response, filter }));
  } else {
    yield put(userInterestsModule.fetchUserInterestsFail(error));
  }
}
export function* watchFetchUserInterests() {
  yield takeEvery(userInterestsModule.fetchUserInterests.getType(), fetchUserInterests);
}

export function* fetchUserInterestDetails({ payload: { externalId } }) {
  const { response, error } = yield call(Api.users.fetchUserInterestDetails, { externalId });

  if (response) {
    yield put(userInterestsModule.fetchUserInterestDetailsSuccess({ userInterestDetails: response }));
  } else {
    yield put(userInterestsModule.fetchUserInterestDetailsFail(error));
  }
}
export function* watchFetchUserInterestDetails() {
  yield takeEvery(userInterestsModule.fetchUserInterestDetails.getType(), fetchUserInterestDetails);
}

export function* openUserInterestDetails({ payload: { externalId } }) {
  yield put(userInterestsModule.fetchUserInterestDetails({ externalId }));
}
export function* watchOpenUserInterestDetails() {
  yield takeEvery(userInterestsModule.openUserInterestDetails.getType(), openUserInterestDetails);
}

export default function* watchUserInterests() {
  return yield all([
    fork(watchFetchUserInterests),
    fork(watchFetchUserInterestDetails),
    fork(watchOpenUserInterestDetails),
  ]);
}




/** WEBPACK FOOTER **
 ** ./js/redux/saga/userInterests.saga.js
 **/